import { useLocation } from "react-router-dom";

const WHATSAPP_NUMBER = "19548059212";

// Nombres legibles por ruta para el mensaje
const PAGE_NAMES = {
  "/": "Inicio",
  "/precios": "Precios",
  "/academia": "Universidad",
  "/cursos": "Universidad",
  "/comunidad": "Videos que hacen dinero",
  "/licencias": "Licencias y Registros",
  "/analisisfinanciero": "Análisis Financiero",
  "/avisocodigos": "Aviso de Códigos de Descuento",
  "/protocolo-2026": "Protocolo 2026",
  "/cenaconcarlos": "Cena con Carlos",
};

const FloatingWhatsApp = () => {
  const location = useLocation();
  const path = location.pathname;
  const pageName = PAGE_NAMES[path] || (path.replace("/", "") || "Inicio");

  const message = encodeURIComponent(
    `Hola, vengo desde la página "${pageName}" de clubviajemos.com y quiero más información.`
  );
  const href = `https://wa.me/${WHATSAPP_NUMBER}?text=${message}`;

  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="floating-whatsapp-btn"
      aria-label="Escríbenos por WhatsApp"
      className="fixed bottom-6 left-5 z-[60] flex items-center justify-center w-14 h-14 rounded-full bg-[#25D366] shadow-[0_8px_30px_rgba(37,211,102,0.5)] hover:scale-110 hover:shadow-[0_10px_36px_rgba(37,211,102,0.65)] transition-all"
    >
      <span className="absolute inline-flex h-full w-full rounded-full bg-[#25D366] opacity-60 animate-ping" />
      <svg viewBox="0 0 32 32" className="relative w-7 h-7 fill-white" aria-hidden="true">
        <path d="M16.003 3.2c-7.06 0-12.8 5.74-12.8 12.8 0 2.26.6 4.46 1.74 6.4L3.2 28.8l6.56-1.72a12.74 12.74 0 0 0 6.24 1.6h.01c7.06 0 12.8-5.74 12.8-12.8s-5.74-12.8-12.81-12.68zm0 23.04h-.01a10.6 10.6 0 0 1-5.4-1.48l-.39-.23-3.89 1.02 1.04-3.79-.25-.39a10.6 10.6 0 0 1-1.62-5.64c0-5.86 4.77-10.63 10.64-10.63 2.84 0 5.51 1.11 7.52 3.12a10.56 10.56 0 0 1 3.11 7.52c0 5.86-4.77 10.63-10.6 10.63zm5.83-7.96c-.32-.16-1.89-.93-2.18-1.04-.29-.11-.5-.16-.71.16-.21.32-.82 1.04-1 1.25-.18.21-.37.24-.69.08-.32-.16-1.35-.5-2.57-1.59-.95-.85-1.59-1.89-1.78-2.21-.18-.32-.02-.49.14-.65.14-.14.32-.37.48-.56.16-.18.21-.32.32-.53.11-.21.05-.4-.03-.56-.08-.16-.71-1.72-.98-2.35-.26-.62-.52-.54-.71-.55-.18-.01-.4-.01-.61-.01-.21 0-.56.08-.85.4-.29.32-1.11 1.09-1.11 2.65 0 1.56 1.14 3.07 1.3 3.28.16.21 2.25 3.44 5.46 4.82.76.33 1.36.53 1.82.68.77.24 1.46.21 2.01.13.61-.09 1.89-.77 2.16-1.52.27-.74.27-1.38.19-1.52-.08-.13-.29-.21-.61-.37z" />
      </svg>
    </a>
  );
};

export default FloatingWhatsApp;
